import { render, staticRenderFns } from "./TrademarkOppositionResponsibleList.vue?vue&type=template&id=00169af4&"
import script from "./TrademarkOppositionResponsibleList.vue?vue&type=script&lang=js&"
export * from "./TrademarkOppositionResponsibleList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkOppositionResponsibleList.vue?vue&type=style&index=0&id=00169af4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports